import React from 'react'
import { Icon } from './MobilePhoneRinging.elements'

type Props = {
  className?: string
}

export const MobilePhoneRingingIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 64 64"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <g clipPath="url(#clip-mobile-phone-ringing)" strokeWidth="1.6">
      <path d="M25.169 51.93H39.19M27.817 10.93h4.363M45.493 17.762v5.367M34.692 10.93h.977" stroke="#1A1C1F" strokeLinecap="round" />
      <rect x="19.585" y="8.8" width="24.918" height="45.257" rx="4.086" stroke="#1A1C1F" />
      <path d="M47.781 37.793c4.575-4.575 4.552-12.015-.05-16.617M51.253 41.265c6.481-6.48 6.449-17.02-.071-23.54M16.35 21.2c-4.575 4.574-4.552 12.014.05 16.616M12.88 17.725c-6.481 6.48-6.45 17.02.071 23.54" stroke="#4CA9ED" />
    </g>
    <defs>
      <clipPath id="clip-mobile-phone-ringing">
        <path fill="#fff" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </Icon>
)
